export default __webpack_public_path__ + "static/media/plus.2f96e108.svg";